(function() {
    $(document).ready(function() {
        window.c24LpCssLoaded.then(function() {
            const oBackToTop = $('.js24BackToTop');
            if (!oBackToTop.length) {
                return;
            }

            function updatePosition() {
                const safeAreaBottom = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sab'), 10);
                const distanceToTabBar = 10;
                const tabBarHeight = 70;
                let iBottom = safeAreaBottom + distanceToTabBar;

                if (!window.c24LpIsApp && window.c24LpIsMobile) {
                    iBottom += tabBarHeight;
                }

                if ($('.social.mobile').length) {
                    iBottom += $('.social.mobile').height();
                } else if ($('.jsBottomFixed').length) {
                    iBottom += $('.jsBottomFixed').outerHeight();
                } else if ($('.c24Button.js24FixableTrigger').is(':visible').length) {
                    $.each($('.c24Button.js24FixableTrigger').is(':visible'), function(index, ele) {
                        const $trigger = $(ele);
                        const $ctaWrapper = $trigger.parent('.js24Fixable');

                        if ($ctaWrapper.hasClass('js24Fixed')) {
                            iBottom += $trigger.parent('.js24Fixable.js24Fixed').outerHeight() + 3;
                            return false;
                        }
                    });
                }

                oBackToTop.css({
                    'bottom': iBottom,
                });
            }

            updatePosition();

            document.addEventListener('scroll', function() {
                updatePosition();
            }, {
                passive: true,
            });

            oBackToTop.on('click', function() {
                $('html').stop().animate({
                    'scrollTop': 0,
                });
            });

            function updateVisibility() {
                if ($(window).scrollTop() < 110 || $(window).width() < 320) {
                    if (oBackToTop.is(':visible')) {
                        oBackToTop.stop().fadeOut('fast');
                    }
                } else {
                    if (oBackToTop.is(':hidden')) {
                        oBackToTop.stop().fadeIn('fast');
                    }
                }
            }

            updateVisibility();

            document.addEventListener('scroll', function() {
                updateVisibility();
            }, {
                passive: true,
            });

            $(window).resize(function() {
                updateVisibility();
            });
        });
    });
})();
